import './index.css';
import { jsx } from 'react/jsx-runtime';
import styles from './text.module.scss.js';

const sizeDefault = (kind) => {
    /* istanbul ignore if -- @preserve */
    switch (kind) {
        case 'feature':
            return 'small';
        case 'title':
            return 'medium';
        default:
            return 'large';
    }
};
/**
 * @component Text
 * @package Typography
 * @document ../_docs/code/Text.editor.tsx
 * @document ../_docs/code/Text.snippet.tsx
 * @document ../_docs/code/Text.import.tsx
 */
const Text = ({ primitive = 'p', bold = false, children, color, viewport, id, 'data-testid': testID, viewportOverride, kind = 'body', size = sizeDefault(kind), strikethrough, }) => {
    const titleStyles = [
        styles.text,
        styles[kind],
        strikethrough ? styles[`strikethrough`] : '',
        styles[size.includes('2') ? size.replace('2', 'two') : size],
    ];
    if (bold)
        titleStyles.push(styles.bold);
    if (viewport)
        titleStyles.push(styles[viewport]);
    const getFontStyle = (override) => {
        if (Object.prototype.hasOwnProperty.call(override, 'bold'))
            return override.bold ? 'bold' : 'regular';
        return bold ? 'bold' : 'regular';
    };
    const stylesObject = {};
    if (viewportOverride) {
        Object.keys(viewportOverride).forEach((viewportType) => {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
            titleStyles.push(...[styles.override, styles[`${viewportType}-override`]]);
            const override = viewportOverride[viewportType];
            stylesObject[`--${viewportType}-fontfamily`] =
                `var(--vds-typography-${(_a = override.kind) !== null && _a !== void 0 ? _a : kind}-${(_b = override.size) !== null && _b !== void 0 ? _b : size}-fontfamily)`;
            stylesObject[`--${viewportType}-fontsize`] =
                `var(--vds-typography-${(_c = override.kind) !== null && _c !== void 0 ? _c : kind}-${(_d = override.size) !== null && _d !== void 0 ? _d : size}-fontsize)`;
            stylesObject[`--${viewportType}-fontweight`] =
                `var(--vds-typography-${(_e = override.kind) !== null && _e !== void 0 ? _e : kind}-${(_f = override.size) !== null && _f !== void 0 ? _f : size}-fontweight-${getFontStyle(override)})`;
            stylesObject[`--${viewportType}-lineheight`] =
                `var(--vds-typography-${(_g = override.kind) !== null && _g !== void 0 ? _g : kind}-${(_h = override.size) !== null && _h !== void 0 ? _h : size}-lineheight)`;
            stylesObject[`--${viewportType}-letterspacing`] =
                `var(--vds-typography-${(_j = override.kind) !== null && _j !== void 0 ? _j : kind}-${(_k = override.size) !== null && _k !== void 0 ? _k : size}-letterspacing-${getFontStyle(override)})`;
            if (override['color'])
                stylesObject[`--${viewportType}-color`] = override['color'];
        });
    }
    const Primitive = primitive;
    return (jsx(Primitive, { id: id, style: Object.assign({ color }, stylesObject), "data-testid": testID, className: titleStyles.join(' '), children: children }));
};

export { Text, Text as default };
